
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutor",
      function () {
        return require("private-next-pages/tutor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutor"])
      });
    }
  